module.exports = __webpack_public_path__ + "static/klee-button-6f6264dd121d73b86b6fa4c1cd21567a.png";